import { Box, Flex, Table, TableContainer, TableProps, Tbody, Td, Th, Thead, Tr, useColorModeValue } from "@chakra-ui/react"
import { ReactNode } from "react";
import { text as textTheme } from "theme/foundations/text";
import { useTable, useSortBy } from "react-table";
import { border } from "theme/foundations/border";
import { radius } from "theme/names";
import { MessageBox } from "components/message-box/message-box";

export interface DynamicTableColumn {
  Header: string | ReactNode;
  accessor: string;
  Cell: (props) => ReactNode;
  width?: string;
  tooltipText?: string;
  sortDescFirst?: true,
  sortType?: any
  isNumeric?: boolean
}

export interface DynamicTableProps {
  columns: DynamicTableColumn[];
  data: any[];
  size?: TableProps['size'];
  sortBy?: any[];
  emptyMessage?: string;
}

export const DynamicTable = ({ columns, data, size, sortBy = [], emptyMessage = 'No data' }: DynamicTableProps) => {


  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable(
      {
        columns,
        data,
        initialState: {
          sortBy
        }
      }, useSortBy);

  const borderColor = useColorModeValue(
    "border.lightMode.light",
    "border.darkMode.light"
  );

  const headerBackgroundColor = useColorModeValue(
    "background.lightMode.medium",
    "background.darkMode.medium"
  );

  return (
    <TableContainer
      borderRadius={radius.lg}
      {...border.default.light}
      {...textTheme.body.medium.light.light}
      _dark={{
        ...border.default.dark,
        ...textTheme.body.medium.light.dark,
      }}
    >
      <Table
        {...getTableProps()}
        variant='unstyled' size={size}
      >
        <Thead borderBottom="1px solid" borderColor={borderColor} backgroundColor={headerBackgroundColor}>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, index) => (
                <Th
                  {...column.getHeaderProps(
                    column.getSortByToggleProps({ title: undefined })
                  )}
                  w={column.width}
                >
                  {column.Header}
                  {/* TODO: Implement sorting -> TweetPerformance */}
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps()}>
          {rows.map((row) => {
            prepareRow(row);
            return (
              <Tr {...row.getRowProps()}
                borderBottom="1px solid" borderColor={borderColor}>
                {row.cells.map((cell) => (
                  <Td
                    {...cell.getCellProps()}
                    px={4} py={3}
                  >
                    {cell.render("Cell")}
                  </Td>
                ))}
              </Tr>
            );
          })}
        </Tbody>
      </Table>
      {
        rows.length === 0 && (
          <Flex justifyContent="center">
            <MessageBox message={emptyMessage} />
          </Flex>
        )
      }
    </TableContainer>
  )
}